import React from 'react';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var InnerElementTypeContext = /*#__PURE__*/React.createContext(EMPTY_OBJECT);
var InnerElementTypeProvider = InnerElementTypeContext.Provider,
  InnerElementTypeConsumer = InnerElementTypeContext.Consumer;
export { InnerElementTypeProvider };
export { InnerElementTypeConsumer };
export default InnerElementTypeContext;